export const PRIMARY_MENU_WIDTH = '2.5rem';

export const PRIMARY_MENU_MOBILE_HEIGHT = '3.125rem';
